import { Icon } from '@pms-digital/design-system';
import { type ComponentProps, useState } from 'react';
import { ChampLogin } from './champ-login';

type ChampMotDePasseProps = Omit<ComponentProps<typeof ChampLogin>, 'type' | 'children'>;

/**
 * The password field: masked by default, with a button in the frame to show or hide
 * what was typed. Switching the type keeps the value, since the input is uncontrolled.
 */
export function ChampMotDePasse(props: ChampMotDePasseProps) {
  const [visible, setVisible] = useState(false);

  return (
    <ChampLogin {...props} type={visible ? 'text' : 'password'}>
      <button
        type="button"
        aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        aria-pressed={visible}
        onClick={() => setVisible((courant) => !courant)}
        className="inline-flex h-full w-[42px] shrink-0 cursor-pointer items-center justify-center rounded-r-md text-gray-500 transition-colors hover:text-gray-800 focus-visible:outline-offset-[-3px]"
      >
        <Icon name={visible ? 'visibility_off' : 'visibility'} size={20} />
      </button>
    </ChampLogin>
  );
}
